import { render, staticRenderFns } from "./DailyChallenge.vue?vue&type=template&id=f573ee10&"
import script from "./DailyChallenge.vue?vue&type=script&lang=tsx&"
export * from "./DailyChallenge.vue?vue&type=script&lang=tsx&"
import style0 from "./daily_challenge.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports